import React from 'react';

import { Skeleton } from '@mui/material';

import { en } from 'localization';
import { SkeletonList, SkeletonRow } from 'shared-components/public-jobs-list';
import {
  PublicContainer,
  PublicFooter,
  PublicMain,
  PublicPageShell,
  PublicSiteHeader,
} from 'shared-components/public-shell';
import { VisuallyHidden } from 'shared-components/state-views';

import {
  JobsListSection,
  ListEyebrow,
  ListHead,
  ListTitle,
} from './styled-components';

const copy = en.publicJobsList;

const SKELETON_ROW_KEYS = [
  'jobs-list-loading-row-1',
  'jobs-list-loading-row-2',
  'jobs-list-loading-row-3',
  'jobs-list-loading-row-4',
  'jobs-list-loading-row-5',
  'jobs-list-loading-row-6',
] as const;

export const JobsListLoading: React.FC = () => (
  <PublicPageShell>
    <PublicSiteHeader openRoles="hide" />

    <PublicMain>
      <PublicContainer>
        <JobsListSection>
          <ListHead>
            <ListEyebrow>{copy.eyebrow}</ListEyebrow>

            <ListTitle>{copy.heading}</ListTitle>

            <Skeleton aria-hidden variant="text" width="14rem" />
          </ListHead>

          <SkeletonList
            aria-busy="true"
            aria-label={copy.loadingLabel}
            role="status"
          >
            <VisuallyHidden>{copy.loadingLabel}</VisuallyHidden>

            {SKELETON_ROW_KEYS.map(key => (
              <SkeletonRow aria-hidden key={key}>
                <Skeleton variant="text" width="45%" />

                <Skeleton variant="text" width="30%" />
              </SkeletonRow>
            ))}
          </SkeletonList>
        </JobsListSection>
      </PublicContainer>
    </PublicMain>

    <PublicFooter />
  </PublicPageShell>
);

export default JobsListLoading;
